// directives/clickOutside.js
export default {
  bind (el, binding, vnode) {
    const handler = (event) => {
      // если клик внутри элемента — игнорируем
      if (!event) return
      if (el === event.target || el.contains(event.target)) return

      const ctx = vnode.context
      const value = binding.value

      // 1) если передана функция — вызываем её в контексте компонента
      if (typeof value === 'function') {
        value.call(ctx, event)
        return
      }

      // 2) если передана строка (имя свойства) — выставляем его в false
      //    usage: v-click-outside="'showSubmenu'"
      if (typeof value === 'string') {
        const propName = value.trim().replace(/^['"]|['"]$/g, '')
        if (propName && Object.prototype.hasOwnProperty.call(ctx, propName)) {
          ctx[propName] = false
        }
        return
      }

      // 3) fallback: если в директиву передали булевое/любое значение — пробуем использовать binding.expression
      //    (редко нужно, но оставим безопасный fallback)
      if (binding.expression && typeof binding.expression === 'string') {
        // например, если кто-то написал v-click-outside="hideMenu()" — binding.value уже undefined,
        // но binding.expression может содержать вызов. Попытка выполнить такой код — НЕ безопасна,
        // поэтому мы здесь ничего не делаем. Лучше использовать явную функцию/строку.

      }
    }

    // сохраняем на элементе, чтобы удалить потом
    el.__vueClickOutside__ = handler
    // слушаем в capture-фазе чтобы перехватить раньше других обработчиков (устойчивее)
    document.addEventListener('click', handler, true)
  },

  unbind (el) {
    document.removeEventListener('click', el.__vueClickOutside__, true)
    delete el.__vueClickOutside__
  }
}



// WEBPACK FOOTER //
// ./src/js/directives/clickOutside.js